import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authConsume } from "@/lib/api";
import { useSpark } from "@/lib/store";
import { SparkSun } from "@/components/SparkSun";

export default function AuthConsume() {
  const nav = useNavigate();
  const { setSession, switchUser } = useSpark();
  const [error, setError] = useState("");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = new URLSearchParams(window.location.search).get("token") || "";
    window.history.replaceState({}, "", "/auth/consume");
    authConsume(token)
      .then(({ user }) => { setSession(user); switchUser(user.user_id); nav("/dashboard", { replace: true }); })
      .catch(e => setError(e?.response?.data?.detail || "This link isn't valid."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center px-6" style={{ background: "hsl(var(--spark-canvas))" }}>
      <div className="max-w-md text-center">
        <SparkSun size={72} color="#C3A56B" strokeWidth={1} className="mx-auto" />
        {!error ? (
          <p data-testid="auth-consuming" className="mt-6 spark-voice text-2xl text-[#17171C]">Signing you in…</p>
        ) : (
          <>
            <p data-testid="auth-error" className="mt-6 spark-voice text-2xl text-[#17171C] leading-snug">{error}</p>
            <Link to="/signin" data-testid="auth-error-signin-link" className="spark-btn-primary mt-8 inline-flex">Ask for a fresh link</Link>
          </>
        )}
      </div>
    </div>
  );
}
